export default __webpack_public_path__ + "static/media/2.0b17e963.png";